import { render, staticRenderFns } from "./NavbarWithBackButton.vue?vue&type=template&id=31c025ed&scoped=true&"
import script from "./NavbarWithBackButton.vue?vue&type=script&lang=js&"
export * from "./NavbarWithBackButton.vue?vue&type=script&lang=js&"
import style0 from "./NavbarWithBackButton.vue?vue&type=style&index=0&id=31c025ed&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c025ed",
  null
  
)

export default component.exports